import { ERole } from './role.enum';

/**
 * Keeps logical and/or commonly used together ERoles as arrays in convenience static immutable fields.
 */
export class RoleGroup {
  /**
   * Keeping notes for potential 'INCIDENT_QUEUES'...
   * Excludes Queues:
   * APPEAL_COURT_QUEUE, CARE_REVIEW_QUEUE, CASE_MANAGEMENT_QUEUE, FINAL_REVIEW_QUEUE, INFO_RECEIVED_QUEUE,
   * OPEN_QUEUE_ADMISSIONS, OPEN_QUEUE_HONOR_CODE, OPEN_QUEUE_REG_OVERRIDES, OPEN_QUEUE_SCHOLARSHIP_APPEALS,
   * PENDING_ASSIGNMENT_QUEUE, REGISTER_D_QUEUE, REGISTER_R_QUEUE, SPEAKUP_QUEUE, TITLE_IX_ADJUDICATION_QUEUE,
   * TITLE_IX_ALL_INQUIRY_QUEUE, TITLE_IX_ALL_INVESTIGATION_QUEUE, TITLE_IX_INVESTIGATION_QUEUE
   *
   */
  public static readonly NON_INCIDENT_QUEUES = [
    ERole.APPEALED_QUEUE,
    ERole.ASSIGNED_QUEUE,
    ERole.IN_PROGRESS_QUEUE,
    ERole.NEEDS_INFO_QUEUE,
    ERole.OPEN_QUEUE_COMPLAINTS,
    ERole.OPEN_QUEUE_CONDUCT,
    ERole.OPEN_QUEUE_GRADE_APPEALS,
    ERole.OPEN_QUEUE_LAW_INFORMATIONAL,
    ERole.OPEN_QUEUE_LAW_VIOLATIONS,
    ERole.OPEN_QUEUE_LUOA_HONOR_CODE,
    ERole.OPEN_QUEUE_OGSA,
    ERole.OPEN_QUEUE_OMBUDSMAN,
    ERole.OPEN_QUEUE_RESIDENT_SAO,
    ERole.OGSA_FACULTY,
    ERole.PENDING_INFO_QUEUE,
    ERole.REFERRED_OUT_QUEUE,
    ERole.REVIEWED_QUEUE,
    ERole.TEAM_REVIEW_QUEUE,
    ERole.TITLE_IX_FINAL_REVIEW_QUEUE,
    ERole.TITLE_IX_INQUIRY_QUEUE,
    ERole.TITLE_IX_REVIEW_QUEUE
  ];

  public static readonly OPEN_QUEUES = [
    ERole.OPEN_QUEUE_ADMISSIONS,
    ERole.OPEN_QUEUE_COMPLAINTS,
    ERole.OPEN_QUEUE_CONDUCT,
    ERole.OPEN_QUEUE_GRADE_APPEALS,
    ERole.OPEN_QUEUE_LAW_INFORMATIONAL,
    ERole.OPEN_QUEUE_LAW_VIOLATIONS,
    ERole.OPEN_QUEUE_LUOA_CLUBS,
    ERole.OPEN_QUEUE_LUOA_HONOR_CODE,
    ERole.OPEN_QUEUE_OGSA,
    ERole.OPEN_QUEUE_OMBUDSMAN,
    ERole.OPEN_QUEUE_REG_OVERRIDES,
    ERole.OPEN_QUEUE_RESIDENT_SAO,
    ERole.OPEN_QUEUE_SCHOLARSHIP_APPEALS,
    ERole.OPEN_QUEUE_SPIRITUAL_ACCOUNTING,
    ERole.OPEN_QUEUE_LUOA_EXTENSIONS,
    ERole.OPEN_QUEUE_LUOA_FN_APPEALS,
    ERole.OPEN_QUEUE_CARE,
    ERole.OPEN_QUEUE_HONOR_CODE,
  ];

  public static readonly STUDENT = [ERole.LUO_STUDENT, ERole.LUOA_STUDENT, ERole.RESIDENT_STUDENT];

  public static readonly STUDENT_COMPLAINT = [
    ERole.LUO_STUDENT,
    ERole.LUOA_STUDENT,
    ERole.GROUP_COMPLAINTS_EX,
    ERole.RESIDENT_STUDENT
  ];

  public static readonly STUDENT_APPEALS = [
    ERole.LUO_STUDENT,
    ERole.GRADE_APPEALS_EX,
    ERole.RESIDENT_STUDENT
  ];

  public static readonly SCHOLARSHIP_APPEALS = [
    ERole.LUO_STUDENT,
    ERole.RESIDENT_STUDENT,
    ERole.GROUP_SCHOLARSHIP_APPEALS
  ];

  public static readonly CSER_GRADE_APPEALS = [
    ERole.RESIDENT_STUDENT,
    ERole.GROUP_CSER_GRADE_APPEALS
  ];

  /**
   * Excludes many TITLE IX roles, only includes the basic title ix office roles
   */
  public static readonly TITLE_IX_OFFICE = [ERole.TITLE_IX_OFFICE, ERole.TITLE_IX_SENIOR_DEPUTY];

  /* Notes for potential other groupings - would need to know what the logic is for groupings to name appropriately */
  // GROUP_HONOR_CODE and OGSA_FACULTY used together 4 times // should it have been GROUP_OGSA_HONOR_CODE?
  // GROUP_LUOA_HONOR_CODE and LUOA_FACULTY used together 3 times
  // GROUP_OGSA_PERSONAL and OGSA_FACULTY used together 2 times
  // ASSIGNED_QUEUE and TEAM_REVIEW_QUEUE used together 1 times
  // GROUP_OGSA_HONOR_CODE and OGSA_FACULTY used together 1 times
  // GROUP_COMPLAINTS_EX, LUO_STUDENT, and RESIDENT_STUDENT used together 3 times
  // GROUP_REG_OVERRIDES, LUO_STUDENT, and RESIDENT_STUDENT used together 1 times
  // GROUP_SCHOLARSHIP_APPEALS, LUO_STUDENT, and RESIDENT_STUDENT used together 3 times
  // GROUP_COMPLAINTS, GROUP_LAW_VIOLATIONS, GROUP_LAW_INFORMATIONAL, and GROUP_RESIDENT_SAO used together 1 times
}
